<template>
    <div>
        <div class="agreement-main-box" v-if="show1">
            <div class="agreement-box">
                <div class="title">{{ title1 }}</div>

                <div class="content-box">
                    <div class="content" v-for="(item, index) in content" :key="index">
                        {{ item }}
                    </div>
                </div>
                <div class="btn" @click="close1">我知道了</div>
            </div>
        </div>
        <div class="agreement-main-box" v-if="show">
            <div class="agreement-box">
                <div class="title">{{ title }}</div>

                <div class="content-box">
                    <div class="content" v-for="(item, index) in contentx" :key="index">
                        {{ item }}
                    </div>
                </div>
                <div class="btn" @click="close">我知道了</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Rule",
    data() {
        return {

        };
    },
    methods: {
        close() {
            this.$emit('close', false)
        },
        close1() {
            this.$emit('close1', false)
        }

    },
    props: {
        show: Boolean,
        show1: Boolean,
        title1: String,
        title: String,
        contentx: Array,
        content: Array
    },
};
</script>

<style scoped>
.agreement-main-box {

    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url("https://qiming-1308147483.cos.ap-chengdu.myqcloud.com/doc%2Fpinzhi_shenghuo_huiyuan_quanyi%2Fcommon%2Flogin-shadow-bg.png") repeat;
    z-index: 9999999;


}

.agreement-box {
    border-radius: 10px;
    background-color: #faf7f2;
    padding: 15px;
    width: 85%;
    box-sizing: border-box;


}

.title {
    text-align: center;
    color: #f94439;
    font-size: 14px;
    padding-bottom: 10px;
}

.content-box {
    max-height: 50vh;
    overflow: auto;



}

.content {
    font-size: 12px;
    color: #515151;
    margin-top: 10px;
    text-align: left;
    line-height: 22px;
}

.btn {
    width: 150px;
    font-size: 12px;
    letter-spacing: 1px;
    color: #fff;
    text-align: center;
    background-color: #f94338;
    border-radius: 60px;
    padding: 6px 0;
    font-size: 16px;
    margin: 5px auto 0;
}
</style>
